import styled from 'styled-components';
import { IconSize, InfoIcon } from '@ardoq/icons';
import { colors, s4 } from '@ardoq/design-tokens';
import { WithPopover } from '@ardoq/popovers';

const HeaderInfoIcon = styled(InfoIcon).attrs({
  iconSize: IconSize.SMALL,
})`
  color: ${colors.grey500};
  margin-left: ${s4};
  padding-bottom: 1px;
  vertical-align: middle;
  cursor: pointer;
`;

export const GroupNameHeaderInfoIcon = () => (
  <WithPopover content="This name will be displayed on the grouped components in a view. For groups by reference, the reference type name will be automatically used if the group name is blank.">
    <HeaderInfoIcon />
  </WithPopover>
);
